import { createContext } from "react";
import type { AppInformation } from "./app-information";

export const AppInformationContext = createContext<AppInformation>({
  appConfigFilePath: "",
  isDockerBuild: false,
});
